<template>
  <div id="manager">
    <div id="sm-menu">
      <img v-on:click="closeMenu()" src="../../assets/close.png" id="close" alt="オンライン専門ZOOMコンパニオン「ズムトーーーク☆」">
      <ul>
        <a href="/"><li class="hover">トップページ</li></a>
        <a href="/menu"><li class="hover">料金システム</li></a>
        <a href="/companion"><li class="hover">コンパニオン</li></a>
        <a href="/service"><li class="hover">サービス紹介</li></a>
        <a href="/contact"><li class="hover">お問い合わせ</li></a>
      </ul>
    </div>
    <SubHeader/>
    <p class="subTitle-row">コンパニオン削除</p>
    <div class="card-contents">
      <p style="text-align:left;">担当者ID：<br>
      <input v-model="id" type="text" name="id" placeholder="例）aaa@gmail.com"></p>
      <p style="text-align:left;">担当者パスワード：<br>
      <input v-model="password" type="text" name="password" placeholder="例）keipro0123"></p>
      <p style="text-align:left;">削除するコンパニオンの名前を入力してください(完全一致)</p>
      <input v-model="name" type="text" name="name" placeholder="例）ケイプロ ケイ子">
      <button v-on:click="deleteUser()" id="serchButton">削除</button>
    </div>
  </div>
</template>
<style scoped>
#manager .subTitle-row{
  background-color:rgba(255,215,0,0.9);
  height: 50px;
  line-height: 50px;
  color: white;
  width: 70%;
  margin:36px auto;
  font-size:24px;
  border-radius: 10px 10px 10px 10px;
  font-weight: bold;
  box-shadow: 4px 4px #555555;
}
span{
  font-size: 16px;
  font-style: italic;
}
.card-contents{
   box-shadow: 4px 4px #555555;
  background-color:rgba(208,255,67,0.7);
  border-radius: 10px 10px 10px 10px;
  width: 70%;
  padding: 2%;
  margin:36px auto;
}
#send{
  border-radius: 20px 20px 20px 20px;
  background-color:rgba(255,215,0,0.9);
  color: white;
  border: 0px inset black;
  width: 200px;
  font-size: 20px;
  margin-top: 36px;
  margin-bottom: 36px;
}
#sm-menu{
  background-color:rgba(0,0,0,0.9);
  display: none;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: black;
  position: fixed;
}
input{
  width: 80%;
  height: 50px;
  font-size: 20px;
}
p{
  width: 80%;
  margin-left: 10%;
  font-size: 24px;
}
#serchButton{
  display: block;
    margin-left: 30%;
    background-color:rgba(255,215,0,1.0);
    width: 40%;
    font-size: 20px;
    border-radius: 30px;
    margin-top: 16px;
    margin-bottom: 16px;
    color: white;
}
#serchButton:hover{
  background-color:orange;
}
@media ( max-width : 680px ){
  .card-contents{
  width: 90%;
}
  #sm-menu li{
    display: block;
   background-image: url(../../assets/bg-body.jpg);
    color: #555555!important;
     margin-left: 16px;
     margin-right: 16px;
    margin-top: 16px;
     margin-bottom: 16px;
     font-size:24px;
     line-height: 70px;
  border-radius: 10px 10px 10px 10px;
  height: 70px;
  }
  #sm-menu  a {
  display: contents;
  text-decoration: none;
   color: white;
}
  #sm-menu ul{
    margin-top: 100px;
    padding : 0;
  }
  .subTitle-row{
    width: 90%;
  }
}
</style>
<script>
import SubHeader from '../common/SubHeader'
import Footer from '../common/Footer'
import firebase from 'firebase'

export default {
  name: 'app',
  components: {
    SubHeader, Footer
  },
  data () {
    return {
      db: null,
      name: '',
      id: '',
      password: ''
    }
  },
  created: function () {
    this.db = firebase.firestore()
  },
  methods: {
    deleteUser: function () {
      if (!this.id) {
        alert('担当者のIDが入力されていません。')
        return
      }
      if (!this.password) {
        alert('担当者のパスワードが入力されていません。')
        return
      }
      var exist = false
      var mExist = false
      var noName = false
      var n = this.name
      var db = this.db
      db.collection('manager').where('id', '==', this.id).where('password', '==', this.password).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          console.log(doc.id, ' => ', doc.data())
          mExist = true
          if (!n) {
            noName = true
            alert('名前を入力してから、検索をしてください')
            return
          }
          db.collection('companions').where('name', '==', n).get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              exist = true
              var DB = firebase.firestore()
              DB.collection('companions').doc(doc.id).delete().then(function () {
                alert('コンパニオンの削除に成功しました！')
              }).catch(function (error) {
                console.error('Error removing document: ', error)
                alert('コンパニオンの削除に失敗しました、再度実行してください！')
              })
            })
            if (!exist) {
              alert('入力されたコンパニオンは存在しません。')
            }
          })
            .catch(function (error) {
              console.log(error)
              if (!noName) {
                alert('登録に失敗しました。エラーです。')
              }
            })
        })
        if (!mExist) {
          if (!noName) {
            alert('入力されたIDとパスワードが異なります。マネージャーは存在しません。')
          }
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('登録に失敗しました。エラーです。')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manager/Delete.vue